import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { HighlightFeedbackPanelService } from '../../services/highlight-feedback-panel.service';

@Component({
  selector: 'h3-toggle-feedback-list-button',
  imports: [MatButtonToggleModule, MatIconModule, CommonModule],
  templateUrl: './toggle-feedback-list-button.component.html',
  styleUrl: './toggle-feedback-list-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleFeedbackListButtonComponent
  extends DirectiveSuperclass
  implements OnInit
{
  private readonly store = inject(TaskWorkspaceStore);
  private readonly feedbackPanelService = inject(HighlightFeedbackPanelService);

  arePanelsOpen$ = this.feedbackPanelService.arePanelsOpen$();
  hasFeedback$ = this.store('highlightFeedbacks').$.pipe(
    map((feedback) => feedback.length > 0),
  );

  ngOnInit() {
    this.subscribeTo(this.hasFeedback$, (hasFeedback) => {
      if (!hasFeedback) {
        this.closePanel();
      }
    });
  }

  togglePanel(isToggled: boolean | null) {
    if (!isToggled) {
      this.feedbackPanelService.showHighlightList('toggle');
    } else {
      this.closePanel();
    }
  }

  private closePanel() {
    this.feedbackPanelService.close();
  }
}
